import { render, staticRenderFns } from "./FormWinners.html?vue&type=template&id=8854b3de&scoped=true&"
import script from "./FormWinners.js?vue&type=script&lang=js&"
export * from "./FormWinners.js?vue&type=script&lang=js&"
import style0 from "./FormWinners.scss?vue&type=style&index=0&id=8854b3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8854b3de",
  null
  
)

export default component.exports